module.exports = "https://r.nearpod.com/assets/media/image/first_lesson-c20a94de53a7db0ad03f90cbf402efca.png";